// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import MealsIncluded from '../_raw/service/icon_meals_included.svg';
import withIconProps from '../withIconProps';

export default withIconProps(MealsIncluded);
